export const SECRETS = {
  API_URL: process.env.REACT_APP_API_URL || "https://localhost:3001/api/",
  SECRET_KEY: process.env.REACT_APP_SECRET_KEY || "",
  TASK_DASHBOARD_REFRESH_TIME:
    process.env.REACT_APP_TASK_DASHBOARD_REFRESH_TIME || 60000,
  UPLOADS_URL:
    process.env.REACT_APP_API_URL +
      "" +
      process.env.REACT_APP_UPLOADS_URL_PATH || "",
  WHISPER_API_PATH: process.env.REACT_APP_WHISPER_API_PATH || "",
  LLAMA_API_PATH: process.env.REACT_APP_LLAMA_API_PATH || "",
};
